// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__r1+ms","logo":"Header_logo__UsziS","link":"Header_link__xIhZh","ham":"Header_ham__45WFg","overlay":"Header_overlay__xH+h6","active":"Header_active__rHuVo"};